import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardHeader, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import ContactLink from '../ContactLink';
import { styles } from './styles';

const useStyles = makeStyles(styles);

const ContactCard = ({ fullName, location, phoneNumber, email }) => {
  const classes = useStyles();

  const field = (label, value) => (
    <>
      <Typography variant="body1" color="textSecondary" className={classes.label}>
        {label}
      </Typography>
      <Typography variant="body1" color="textPrimary" className={classes.value}>
        {value}
      </Typography>
    </>
  );

  return (
    <Card className={classes.root}>
      <CardHeader title={fullName} classes={{ root: classes.header }} />

      {!!location && (
        <>
          <Divider />
          <div className={classes.section}>{field('Primary Location:', location)}</div>
        </>
      )}

      {(!!email || !!phoneNumber) && (
        <>
          <Divider />
          <div className={classes.section}>
            {!!email && field('Email:', <ContactLink scheme="mailto" value={email} />)}
            {!!phoneNumber && field('Phone:', <ContactLink scheme="tel" value={phoneNumber} />)}
          </div>
        </>
      )}
    </Card>
  );
};

ContactCard.propTypes = {
  fullName: PropTypes.string.isRequired,
  location: PropTypes.string,
  phoneNumber: PropTypes.string,
  email: PropTypes.string,
};

ContactCard.defaultProps = {
  location: '',
  phoneNumber: '',
  email: '',
};

export default ContactCard;
